import useRead from "../useRead";
import { toast } from "react-hot-toast";

const useGetCustomers = ({ limit = 50 } = {}) => {
  const initialData = {
    pageNo: 0,
    limit: limit,
    searchQuery: "",
    name: "",
    phone: "",
    email: "",
    city: "",
    state: "",
    customer_type: "",
    status: "active",
    registered_from: "",
    registered_to: "",
    business_registered_from: "",
    business_registered_to: "",
  };

  const handlePageClick = (val) => {
    setGetListParams({
      ...paramsObject,
      pageNo: val.selected,
    });
  };

  const handleSetLimit = (e) => {
    const value = Number(e.target.value);
    setGetListParams({
      ...paramsObject,
      limit: value,
      pageNo: 0,
    });
  };

  const { data, paramsObject, setGetListParams } = useRead({
    initialData,
    url: "customers/list",
    method: "GET",
    keepPreviousData: true,
    onError: (err) => {
      toast.error(err.message || "Failed to fetch customers");
    },
  });

  const handleKeyDown = (e, searchInputs) => {
    if (e.key === "Enter") {
      setGetListParams({
        ...paramsObject,
        ...searchInputs,
        pageNo: 0,
      });
    }
  };

  return {
    data,
    paramsObject,
    setGetListParams,
    handlePageClick,
    handleKeyDown,
    handleSetLimit,
    initialData,
  };
};

export default useGetCustomers;
